module.exports = true;


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/core-js/library/modules/_library.js
// module id = 130
// module chunks = 0